import 'angular:locale/data:fa-IR';
import 'angular:locale/data:zh-CN';
import 'angular:locale/data:vi-VN';
import 'angular:locale/data:uz-UZ';
import 'angular:locale/data:uk-UA';
import 'angular:locale/data:tr-TR';
import 'angular:locale/data:th-TH';
import 'angular:locale/data:ta-IN';
import 'angular:locale/data:tg-TJ';
import 'angular:locale/data:ru-RU';
import 'angular:locale/data:pt-BR';
import 'angular:locale/data:my-MM';
import 'angular:locale/data:ms-MY';
import 'angular:locale/data:km-KH';
import 'angular:locale/data:kk-KZ';
import 'angular:locale/data:ka-GE';
import 'angular:locale/data:id-ID';
import 'angular:locale/data:hy-AM';
import 'angular:locale/data:fr-FR';
import 'angular:locale/data:es-ES';
import 'angular:locale/data:en-US';
import 'angular:locale/data:bg-BG';
import 'angular:locale/data:az-AZ';
import 'angular:locale/data:ru';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
